import { useHistory } from "react-router-dom";

export const usePageRoot = () => {
  const history = useHistory();
  const pageRoot = history.location.pathname.split("/")[1];
  return pageRoot;
};
